import planApi from '@/api/plan/plan_api.js'

const state = {
    my_plans: [],
    my_notes: [],
    my_todos: localStorage.getItem('my_todos') ? localStorage.getItem('my_todos') : [],
    my_todos_by_date: [],
    my_plans_by_date: [],
    plan_information: {},
    active_detail_type: 'all',
    ref_page: 'mobileplan',
    active_plan_layout: localStorage.getItem('active_plan_layout') ? localStorage.getItem('active_plan_layout') : 'month',
    active_date: localStorage.getItem('active_date') ? localStorage.getItem('active_date') : (new Date()),
    active_plan_type: localStorage.getItem('active_plan_type') ? localStorage.getItem('active_plan_type') : 'month',
    active_plan_id: localStorage.getItem('active_plan_id') ? localStorage.getItem('active_plan_id') : 0,
    new_plan_startDate: localStorage.getItem('new_plan_startDate') ? localStorage.getItem('new_plan_startDate') : '',
    new_plan_endDate: localStorage.getItem('new_plan_endDate') ? localStorage.getItem('new_plan_endDate') : '',
    display_plans_params: localStorage.getItem('display_plans_params') ? JSON.parse(localStorage.getItem('display_plans_params')) : {},
}
const getters = {
    display_plans: state => {
        let p = []
        for (var i = 0; i < state.my_plans.length; i++) {
            if ((new Date(state.my_plans[i].open_time)).getFullYear() == (new Date(state.display_plans_params.date)).getFullYear()) {
                p.push(state.my_plans[i])
            }
        }
        return p
    },
    display__details: state => {
        let p0 = []
        let p1 = []
        let p2 = []
        let p3 = []
        let p4 = []
        for (var i = 0; i < state.my_todos.length; i++) {
            if (state.active_detail_type == 'all' || state.my_todos[i].detail_type == state.active_detail_type) {
                if (state.my_todos[i].isImportant && state.my_todos[i].isEmergency) {
                    p1.push(state.my_todos[i])
                }
                if (state.my_todos[i].isImportant && !state.my_todos[i].isEmergency) {
                    p2.push(state.my_todos[i])
                }
                if (!state.my_todos[i].isImportant && state.my_todos[i].isEmergency) {
                    p3.push(state.my_todos[i])
                }
                if (!state.my_todos[i].isImportant && !state.my_todos[i].isEmergency) {
                    p4.push(state.my_todos[i])
                }
            }
        }
        p0.push(p1)
        p0.push(p2)
        p0.push(p3)
        p0.push(p4)
        return p0
    },
    display_notes: state => {
        let p = []
        for (var i = 0; i < state.my_notes.length; i++) {
            p.push(state.my_notes[i])
        }
        return p
    },
}
const mutations = {
    get_my_plans(state, pInformation) {
        state.my_plans = pInformation
    },
    get_plans_by_user(state, pInformation) {
        state.my_plans = pInformation
    },
    get_my_notes(state, pInformation) {
        state.my_notes = pInformation
    },
    get_my_todos(state, pInformation) {
        state.my_todos = pInformation
    },
    get_todos_by_user(state, pInformation) {
        state.my_todos = pInformation
    },
    get_my_todos_by_date(state, pInformation) {
        state.my_todos_by_date = pInformation
    },
    get_my_plans_by_date(state, pInformation) {
        state.my_plans_by_date = pInformation
    },
    get_plan_info(state, pInformation) {
        state.plan_information = pInformation
    },
    change_display_plans_params(state, display_plans_params) {
        state.display_plans_params = display_plans_params
    },
    change_active_plan_layout(state, layout) {
        state.active_plan_layout = layout
    },
    change_active_date(state, date) {
        state.change_active_date = date
    },
    change_active_plan_type(state, plantype) {
        state.active_plan_type = plantype
    },
    change_active_detail_type(state, plantype) {
        state.active_detail_type = plantype
    },
    change_new_plan_startDate(state, startDate) {
        state.new_plan_startDate = startDate
    },
    change_new_plan_endDate(state, endDate) {
        state.new_plan_endDate = endDate
    },
    change_active_plan_id(state, planId) {
        state.active_plan_id = planId
    },
    change_ref_page(state, pageName) {
        state.ref_page = pageName
    },
    delete_plan(state, planId) {
        let index
        for (let i = 0; i < state.my_plans.length; i++) {
            if (state.my_plans[i].id === planId) {
                index = i
                break
            }
        }
        state.my_plans.splice(index, 1)
    },
}

const actions = {
    get_my_plans(context) {
        planApi.get_my_plans().then((response) => {
            context.commit('get_my_plans', response.data)
        })
    },
    get_plans_by_user(context,uid) {
                  let args = {
                'uid': uid,
            }
            console.log(args)
        planApi.get_plans_by_user(args).then((response) => {
            context.commit('get_plans_by_user', response.data)
        })
    },
    get_my_notes(context) {
        planApi.get_my_notes().then((response) => {
            context.commit('get_my_notes', response.data)
        })
    },
    get_my_todos(context) {
        planApi.get_my_todos().then((response) => {
            context.commit('get_my_todos', response.data)
        })
    },
    get_todos_by_user(context,uid) {
                  let args = {
                'uid': uid,
            }
        planApi.get_todos_by_user(args).then((response) => {
            context.commit('get_todos_by_user', response.data)
        })
    },
    get_my_todos_by_date(context) {
        planApi.get_my_todos_by_date(context).then((response) => {
            context.commit('get_my_todos_by_date', response.data)
        })
    },
   get_my_plans_by_date(context) {
        planApi.get_my_plans_by_date(context).then((response) => {
            context.commit('get_my_plans_by_date', response.data)
        })
    },
    get_plan_info(context, planId) {
        planApi.get_plan_info(planId).then((response) => {
            context.commit('get_plan_info', response.data)
        })
    },
    change_display_plans_params(context, display_plans_params) {
        localStorage.setItem('display_plans_params', JSON.stringify(display_plans_params))
        context.commit('change_display_plans_params', display_plans_params)
    },
    change_active_plan_layout(context, layout) {
        localStorage.setItem('active_plan_layout', layout)
        context.commit('change_active_plan_layout', layout)
    },
    change_active_date(context, date) {
        localStorage.setItem('change_active_date', date)
        context.commit('change_active_date', date)
    },
    change_active_detail_type(context, plantype) {
        localStorage.setItem('change_active_detail_type', plantype)
        context.commit('change_active_detail_type', plantype)
    },
    change_active_plan_type(context, plantype) {
        localStorage.setItem('active_plan_type', plantype)
        context.commit('change_active_plan_type', plantype)
    },
    change_new_plan_startDate(context, date) {
        localStorage.setItem('new_plan_startDate', date)
        context.commit('change_new_plan_startDate', date)
    },
    change_new_plan_endDate(context, date) {
        localStorage.setItem('new_plan_endDate', date)
        context.commit('change_new_plan_endDate', date)
    },
    change_active_plan_id(context, planId) {
        localStorage.setItem('active_plan_id', planId)
        context.commit('change_active_plan_id', planId)
    },
    change_ref_page(context, pageName) {
        localStorage.setItem('change_ref_page', pageName)
        context.commit('change_ref_page', pageName)
    },
    async delete_plan(context, args) {
        let res = await planApi.delete_plan(args)
        if (res.status === 200 && res.data.code === 'success') {
            context.commit('delete_plan', args.plan_id)
        }
        return res
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
